import type { FormStepId } from 'shared/config/formStepId';

import { setIsStepFullFilledByStepId } from 'entities/creditForm';

export const submitSummaryThunk =
  (currentStepId?: ValuesOf<typeof FormStepId>): ThunkResult<void> =>
  async (dispatch) => {
    if (currentStepId) {
      dispatch(
        setIsStepFullFilledByStepId({
          stepId: currentStepId,
          isFullFilled: true,
        }),
      );
    }
  };
